import { TableHead, TableHeader, TableRow } from '@/components/ui';

const DataTableHeader = () => {
	return (
		<TableHeader>
			<TableRow>
				<TableHead className="w-[80px]">Bannière</TableHead>
				<TableHead>Titre</TableHead>
				<TableHead className="w-[140px]">Type</TableHead>
				<TableHead className="w-[120px]">Statut</TableHead>
				<TableHead className="w-[140px]">Début</TableHead>
				<TableHead className="w-[140px]">Fin</TableHead>
				<TableHead className="w-[100px] text-center">Inscrits</TableHead>
				<TableHead className="w-[100px]">Prix</TableHead>
				<TableHead className="w-[100px] text-right">Actions</TableHead>
			</TableRow>
		</TableHeader>
	);
};

export default DataTableHeader;
